import { useRef, useContext, useState, useEffect } from 'react';

import { GlobalContext } from "../contexts/globalContext";

import styles from './LoginComponent.module.css';

import en from "../langs/en.json";
import ro from "../langs/ro.json";

import Lottie from 'react-lottie-player';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'

import New_InputTextComponent from './keyboard/New_InputTextComponent';
import LightButtonComponent from './commons/LightButtonComponent';
import LiftPanelButton from './commons/LiftPanelButton';
import ShutdownButton from './commons/ShutdownButton';

import video from '../graphics/big wave fundal loop_6.mp4';
import enImg from '../graphics/en.svg';
import roImg from '../graphics/ro.svg';
import arrowLeft from '../graphics/arrow-left-animation.json';
import icPres from '../graphics/ic-presentation.svg'

import { ApiLoginUser, ApiLoginGuest } from '../utils/RestServices'

const LoginComponent = () => {

    const ref = useRef();
    const inputGuestNameRef = useRef();
    const inputUserNameRef = useRef();
    const inputPasswordRef = useRef();
    const timerForStartingConference = useRef();
    const loginUserPassFormRef = useRef();
    const inputGuestPassRef = useRef()
    const deskDataRef = useRef();

    const [showContent, setShowContent] = useState(true);
    const [currentMeeting, setCurrentMeeting] = useState();
    const [userIsMeetMod, setUserIsMeetMod] = useState(true);

    const {
        keyboardRef, setConferencePaused, socketRef, setAlertMessage, deskData, language, setLanguage, setCurrentUser, invitationData, appHeight, appWidth, setCurrentConference,
        setCurrentParticipant, setWaitingForJoining, socketToken, setSocketToken, localSocketRef, setIamSubAdministrator, setSelectedProject, currentConference,
    } = useContext(GlobalContext);

    useEffect(() => {
        if (inputPasswordRef.current) {
            inputPasswordRef.current.disabled = true;
        }

        return () => {
            CloseTimeoutForStartingConference();
        }
    }, [])

    useEffect(() => {
        if (socketToken) {
            socketRef.current.on('PRESENTATION_ENTER', PresentationEnterHandler);
            socketRef.current.on('PRESENTATION_EXIT', PresentationExitHandler);
            socketRef.current.on('MEETING_ENTER', meetingEnterHandler);
            socketRef.current.on('MEETING_EXIT', meetingExitHandler);
        }

        return () => {
            socketRef.current?.off('PRESENTATION_STARTED');
            socketRef.current?.off('PRESENTATION_ENTER', PresentationEnterHandler);
            socketRef.current?.off('PRESENTATION_EXIT', PresentationExitHandler);
            socketRef.current?.off('MEETING_ENTER', meetingEnterHandler);
            socketRef.current?.off('MEETING_EXIT', meetingExitHandler);
        }
    }, [socketToken])

    useEffect(() => {
        if (deskData) {
            socketRef.current.emit("GET_NEXT_OR_ACTIVE_CONFERENCE", deskData._id, (data) => {
                if (!data.error && data.conference) {
                    console.log("am gasit o conferinta activa sau viitoare");
                    CloseTimeoutForStartingConference();
                    timerForStartingConference.current = setTimeout(() => {
                        if (data.conference.type === "Meeting") {
                            setCurrentMeeting(data.conference);
                        } else {
                            setCurrentParticipant(data.participant);
                            setCurrentConference(data.conference);

                            setConferencePaused(data.conference.paused);

                        }
                    }, data.conference.millisUntilStart);
                } else {
                    console.log("nu am gasit o conferinta activa sau viitoare");
                }
            });

            socketRef.current.on('REFRESH_CONFERENCES', function () {
                socketRef.current.emit("GET_NEXT_OR_ACTIVE_CONFERENCE", deskData._id, (data) => {
                    if (!data.error && data.conference) {
                        console.log("am gasit o conferinta activa sau viitoare");

                        CloseTimeoutForStartingConference();
                        timerForStartingConference.current = setTimeout(() => {
                            if (data.conference.type !== "Meeting") {
                                setCurrentParticipant(data.participant);
                                setCurrentConference(data.conference);


                                setConferencePaused(data.conference.paused);
                            } else if (currentConference) {
                                setCurrentConference(data.conference)


                            } else {
                                setCurrentMeeting(data.conference)
                            }

                        }, data.conference.millisUntilStart);
                    } else {
                        console.log("nu am gasit o conferinta activa sau viitoare");
                    }
                });
            });

            socketRef.current.on('PRESENTATION_STARTED', function (conference) {
                if (deskData && conference.rooms.includes(deskData.room._id)) {
                    socketRef.current.emit("GET_NEXT_OR_ACTIVE_CONFERENCE", deskData._id, (data) => {
                        if (!data.error && data.conference) {
                            if (data.conference.type !== "Meeting") {
                                setWaitingForJoining(true);
                                setCurrentParticipant(data.participant);
                                setCurrentConference(data.conference);


                                setConferencePaused(data.conference.paused);
                            } else {
                                setCurrentMeeting(data.conference)
                            }
                        }
                    });
                }
            });

            socketRef.current.emit("IS_ROOM_IN_PRESENTATION", deskData.room._id, (isInPresentation) => {
                setShowContent(!isInPresentation);
                keyboardRef.current.hideIt();
            });

            socketRef.current.on('CONFERENCE_STOPED', function () {
                setCurrentMeeting()
                socketRef.current.emit("GET_NEXT_OR_ACTIVE_CONFERENCE", deskData._id, (data) => {
                    if (!data.error && data.conference) {
                        console.log("am gasit o conferinta activa sau viitoare");

                        CloseTimeoutForStartingConference();
                        timerForStartingConference.current = setTimeout(() => {
                            if (data.conference.type !== "Meeting") {
                                setCurrentParticipant(data.participant);
                                setCurrentConference(data.conference);


                                setConferencePaused(data.conference.paused);
                            } else if (currentConference) {
                                setCurrentConference(data.conference)


                            } else {
                                setCurrentMeeting(data.conference)
                            }

                        }, data.conference.millisUntilStart);
                    } else {
                        console.log("nu am gasit o conferinta activa sau viitoare");
                    }
                });
            });
        }
        deskDataRef.current = deskData;

    }, [deskData])

    function changeUserNameAndJoin() {
        if (invitationData) {

            if (inputGuestNameRef.current.value && inputGuestPassRef.current.value) {
                var body = JSON.stringify({
                    name: inputGuestNameRef.current.value,
                    password: inputGuestPassRef.current.value,
                    userId: invitationData.userId
                });

                ApiLoginGuest(body, data => {

                    if (!data.error) {
                        CloseTimeoutForStartingConference();
                        setSocketToken(data.response.token)

                        setTimeout(() => {
                            socketRef.current.emit("GET_CONFERENCE_BY_ID", invitationData.conferenceId, (callback) => {
                                if (!callback.error) {
                                    if (callback.response.status !== "Done") {
                                        setWaitingForJoining(true);
                                        setCurrentConference(callback.response);


                                        setConferencePaused(callback.response.paused);
                                        setCurrentParticipant(data.response);
                                        if (callback.response.type === "Meeting") {
                                            setSelectedProject(callback.project)
                                        }
                                    } else {
                                        setAlertMessage({ type: "ERROR", message: "This conference has ended, therefore joining it is no longer possible." });

                                    }

                                } else {
                                    setAlertMessage({ type: "ERROR", message: callback.message });
                                }

                            })
                        }, 1000);


                    } else {
                        setAlertMessage({ type: "ERROR", message: "Login error: user data or password wrong" });
                    }
                });

            } else {
                setAlertMessage({ type: "ERROR", message: "Credentials required" });
            }
        }
    }

    function startQuickPresentation() {
        if (inputUserNameRef.current.value && inputPasswordRef.current.value) {
            var body = {
                email: inputUserNameRef.current.value,
                password: inputPasswordRef.current.value,
                deskId: deskData._id,
                roomId: deskData.room._id ? deskData.room._id : deskData.room
            };
            socketRef.current.emit("GET_QUICK_PRESENTATION", body, (data) => {
                if (!data.error) {
                    CloseTimeoutForStartingConference();
                    if (data.conference.status === "New" || data.isSubAdmin) {
                        setWaitingForJoining(false);
                    }

                    setCurrentParticipant(data.participant);

                    setCurrentConference(data.conference);



                    setConferencePaused(data.conference.paused);

                    setConferencePaused(false);

                    setIamSubAdministrator(data.isSubAdmin);

                    keyboardRef.current.hideIt();


                } else {
                    setAlertMessage({ type: "ERROR", message: data.message });
                }
            });
        } else {
            setAlertMessage({ type: "ERROR", message: "Credentials required" });
        }
    }

    function loginUser() {
        if (inputUserNameRef.current.value && inputPasswordRef.current.value) {
            var body = JSON.stringify({
                email: inputUserNameRef.current.value,
                password: inputPasswordRef.current.value
            });

            ApiLoginUser(body, data => {
                if (!data.error) {
                    CloseTimeoutForStartingConference();
                    setSocketToken(data.response.token)


                    if (invitationData) {
                        setTimeout(() => {
                            socketRef.current.emit("GET_CONFERENCE_BY_ID", invitationData.conferenceId, (callback) => {
                                setWaitingForJoining(true);
                                setCurrentConference(callback.response);


                                setConferencePaused(callback.response.paused);
                                setCurrentParticipant(data.response);
                            })
                        }, 1000);

                    } else {
                        setCurrentUser(data.response);
                    }

                } else {
                    setAlertMessage({ type: "ERROR", message: "Login error: user data or password wrong" });
                }
            });
        } else {
            setAlertMessage({ type: "ERROR", message: "Credentials required" });
        }
    }

    const CloseTimeoutForStartingConference = () => {
        if (timerForStartingConference.current) {
            clearTimeout(timerForStartingConference.current);
            timerForStartingConference.current = null;
        }
    }

    const PresentationEnterHandler = (conference) => {
        if (deskDataRef.current && conference.rooms.includes(deskDataRef.current.room._id)) {
            setShowContent(false);
            keyboardRef.current.hideIt();
        }
    }

    const PresentationExitHandler = (conference) => {
        if (deskDataRef.current && conference.rooms.includes(deskDataRef.current.room._id)) {
            setShowContent(true);
        }
    }

    const meetingEnterHandler = (conference) => {
        if (conference.rooms.includes(deskDataRef.current.room._id)) {
            setUserIsMeetMod(false)
        }
    }

    const meetingExitHandler = (conference) => {
        if (conference.rooms.includes(deskDataRef.current.room._id)) {
            setUserIsMeetMod(true)
        }
    }

    const UserOrEmailOnChangeHandler = () => {
        const emailValue = inputUserNameRef.current?.value || "";

        if (emailValue.trim() === "") {
            inputPasswordRef.current.disabled = true;
            inputPasswordRef.current.value = ""; // Clear password field
        } else {
            inputPasswordRef.current.disabled = false;
        }
    };

    const startMeeting = () => {
        if (inputUserNameRef.current.value && inputPasswordRef.current.value) {

            if (!currentMeeting) {
                setAlertMessage({ type: "ERROR", message: "No meeting found" });
                return;
            }

            var body = {
                email: inputUserNameRef.current.value,
                password: inputPasswordRef.current.value,
                meetId: currentMeeting._id,
                deskId: deskData._id,
                isModerator: userIsMeetMod
            };

            socketRef.current.emit("GET_MEETING", body, (data) => {
                if (!data.error) {
                    CloseTimeoutForStartingConference();

                    if ((data.conference.status === "New" && data.conference.moderatedBy === data.user._id) ||
                        (data.conference.status === "Active" && data.conference.paused === false)) {
                        setWaitingForJoining(false)
                    }

                    setCurrentParticipant(data.user);
                    setCurrentConference(data.conference);


                    setConferencePaused(data.conference.paused);

                    setSelectedProject(data.project)

                    keyboardRef.current.hideIt();
                } else {
                    setAlertMessage({ type: "ERROR", message: data.message });
                }
            });
        } else {
            setAlertMessage({ type: "ERROR", message: "Credentials required" });
        }
    }

    return (
        <div ref={ref} className={styles.component} style={{ height: `${appHeight}px`, width: `${appWidth}px` }}>

            <video id="background-video" autoPlay loop playsInline muted style={{ height: `${appHeight}px`, width: `${appWidth}px` }}>
                <source src={video} type="video/mp4" />
            </video>
            {showContent &&
                <>
                    <div className={styles.inputFields}>
                        <div className={styles.languageChoices}>
                            <img src={enImg} alt="enImg" className={styles.languageButton} onClick={() => setLanguage(en)} style={{ border: language === en ? "4px solid #FFFFFF" : "" }} />
                            <img src={roImg} alt="enImg" className={styles.languageButton} onClick={() => setLanguage(ro)} style={{ border: language === ro ? "4px solid #FFFFFF" : "" }} />
                        </div>
                        <div >
                            <div className={styles.headerText}>Welcome!</div>
                            <div className={styles.headerDetails}>{language.login_page.Please}</div>
                        </div>

                        <div className={styles.loginChoices}>
                            {invitationData?.userId && <div className={styles.guestLogin}>
                                <New_InputTextComponent ref={inputGuestNameRef} keyboardRef={keyboardRef} value={invitationData.name} fontSize="40px"
                                    iconPosition="right" icon={byPrefixAndName.fas["user-tie"]} withDelete={true} placeHolder="Name" styleType='POPUP' width="100%" height="80px" />
                                <New_InputTextComponent ref={inputGuestPassRef} type="password" keyboardRef={keyboardRef} value="" placeHolder={language.login_page.Password} fontSize="40px"
                                    styleType='POPUP' width="100%" height="80px" marginTop="40px" marginBottom="50px" />
                                <div className={styles.lineVisitor} style={{ marginTop: "50px" }}></div>
                                <LightButtonComponent onClick={() => changeUserNameAndJoin()} style={{ width: 251, height: 82, marginTop: 50 }}>
                                    <Lottie
                                        loop={true}
                                        play={true}
                                        animationData={arrowLeft}
                                        style={{ position: "relative", width: 60, height: 35, marginRight: 10 }}
                                    />
                                    <div className={styles.loginPos}> Join</div>
                                </LightButtonComponent>
                            </div>}
                            {!invitationData?.userId && <div className={styles.guestLogin} >
                                <div className={styles.visitorDiv} style={{ marginTop: "60px" }}>
                                    <div className={styles.lineVisitor}></div>
                                    <div className={styles.textChoice}>Login with an email and password</div>
                                    <div className={styles.lineVisitor}></div>
                                </div>
                                <div ref={loginUserPassFormRef} style={{ width: "100%", display: "flex", flexDirection: "column" }}>

                                    <New_InputTextComponent ref={inputUserNameRef} keyboardRef={keyboardRef} value={""} fontSize="40px"
                                        iconPosition="right" icon={byPrefixAndName.fas["pen"]} withDelete={true} placeHolder="Email" styleType='POPUP' width="100%" height="80px"
                                        onChange={() => UserOrEmailOnChangeHandler()} />

                                    <New_InputTextComponent ref={inputPasswordRef} type="password" keyboardRef={keyboardRef} value="" placeHolder={language.login_page.Password} fontSize="40px"
                                        styleType='POPUP' width="100%" height="80px" marginTop="40px" marginBottom="50px" onChange={() => UserOrEmailOnChangeHandler()} />
                                </div>

                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                    {deskData && <LightButtonComponent onClick={startMeeting}
                                        style={{ width: 312, height: 82, font: "normal normal 600 40px/33px Bio Sans", alignItems: "center", gap: 20 }}>
                                        <FontAwesomeIcon icon={byPrefixAndName.far["users"]} style={{ width: 42 }} />
                                        Meeting
                                    </LightButtonComponent>}
                                    {deskData && currentMeeting?.status !== "Active" && <LightButtonComponent onClick={startQuickPresentation}
                                        style={{ width: 386, height: 82, font: "normal normal 600 40px/33px Bio Sans", alignItems: "center", gap: 20 }}>
                                        <img src={icPres} className={styles.icon} />
                                        Presentation
                                    </LightButtonComponent>}
                                    {currentMeeting?.status !== "Active" && <LightButtonComponent onClick={loginUser}
                                        style={{ width: 364, height: 82, font: "normal normal 600 40px/33px Bio Sans", alignItems: "center", gap: 20 }}>
                                        <FontAwesomeIcon icon={byPrefixAndName.far["pen-field"]} style={{ width: 42 }} />
                                        Workspace
                                    </LightButtonComponent>}
                                </div>
                            </div>}
                        </div>
                    </div>
                </>
            }

            {localSocketRef.current?.connected && <ShutdownButton showContent={showContent}></ShutdownButton>}
            {localSocketRef.current?.connected && <LiftPanelButton showContent={showContent}></LiftPanelButton>}
        </div>
    );
}

export default LoginComponent;
